import { render } from "./vpostingdetails.vue?vue&type=template&id=ccb0c874&scoped=true"
import script from "./vpostingdetails.vue?vue&type=script&lang=js"
export * from "./vpostingdetails.vue?vue&type=script&lang=js"

import "./vpostingdetails.vue?vue&type=style&index=0&id=ccb0c874&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccb0c874"]])

export default __exports__